import { render, staticRenderFns } from "./Recommandation.vue?vue&type=template&id=0ec15d28&scoped=true&"
import script from "./Recommandation.vue?vue&type=script&lang=js&"
export * from "./Recommandation.vue?vue&type=script&lang=js&"
import style0 from "./Recommandation.vue?vue&type=style&index=0&id=0ec15d28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec15d28",
  null
  
)

export default component.exports